// src/admin/SudoBanner.jsx
import React from 'react';
import api from '../utils/api';
import { Button } from '@mui/material';
import { useUser } from '../context/UserContext';

export default function SudoBanner({ onExit }) {
  const { user, setUser } = useUser();
  const [sudoUser, setSudoUser] = React.useState(null);

  // Update banner whenever the current user changes
  React.useEffect(() => {
    if (user && user.sudo_source_user_id) {
      setSudoUser(user);
    } else {
      setSudoUser(null);
    }
  }, [user]);

  React.useEffect(() => {
    if (sudoUser) {
      document.body.classList.add('sudo-mode-active');
      return () => document.body.classList.remove('sudo-mode-active');
    }
  }, [sudoUser]);

  const exitSudo = async () => {
    if (onExit) {
      onExit();
      return;
    }
    try {
      const res = await api.post('/users/sudo/exit');
      const { access_token: token, data } = res.data;
      if (token) {
        localStorage.setItem('access_token', token);
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
      }
      if (data) {
        setUser(data);
      }
    } catch (_) {
      // ignore
    } finally {
      localStorage.removeItem('orig_access_token');
    }
  };

  if (!sudoUser) return null;

  return (
    <div style={{
      backgroundColor: '#ffcc00',
      padding: '8px 16px',
      position: 'fixed',
      top: 0,
      width: '100%',
      // Ensure the banner remains above MUI AppBars (z-index 1100)
      zIndex: 1300,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <span>
        SUDO MODE: You are acting as {sudoUser.name} ({sudoUser.email})
      </span>
      <Button
        size="small"
        variant="outlined"
        onClick={exitSudo}
      >
        Exit Sudo
      </Button>
    </div>
  );
}
